import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IConflictSearch } from '../interface/conflictSearch';

interface IFetchConflictSearchesById {
  id?: string;
  relations?: string[];
  fields?: string[];
}
export const useFetchConflictSearchesById = (params: IFetchConflictSearchesById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const conflictSearchUrl = `${API_URLS.CONFLICT_SEARCHES}/${id}`;
  const url = queryString ? `${conflictSearchUrl}?${queryString}` : conflictSearchUrl;
  const query = useQuery<IConflictSearch, Error>({
    queryKey: ['conflict-search-details', id],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: !!id,
  });

  return query;
};
